import { isEmpty } from 'lodash';
import { parseFullName } from 'parse-full-name';

export const getFullName = (...args: (string | undefined | null)[]) =>
  `${args
    .filter((name) => !isEmpty(name))
    .map((name) => `${name}`.trim())
    .join(' ')}`;

interface Person {
  firstName?: string | null;
  lastName?: string | null;
}
export function getAllNames(
  people: (Person | undefined | null)[] | null | undefined,
  separator = ', ',
) {
  if (!people) return '';
  return people
    .filter((person): person is Person => !!person)
    .map(({ firstName, lastName }) => getFullName(firstName, lastName))
    .join(separator);
}

export function parseFirstLastName(fullName: string) {
  const { title, first, middle, last, suffix } = parseFullName(fullName);
  const firstName = `${title} ${first} ${middle}`.trim();
  const lastName = `${last} ${suffix}`.trim();

  // When a single word is provided the parser will treat it as is the
  // last name, but we prefer to treat it as the first name.
  if (!firstName) {
    return {
      firstName: lastName,
      lastName: '',
    };
  }

  return {
    firstName,
    lastName,
  };
}
